<script setup lang="ts">
import RotateChevron from "@/components/RotateChevron.vue"
import type { ChampionshipRegistrationTeam } from "@/model/championship/championship-registration-team"
import type { ChampionshipRegistrationTeamChangeRequest } from "@/model/championship/championship-registration-team-change-request"
import { defineTranslations } from "@/utils/defineTranslations"
import { $date, $datetime, VfComposeOpenRow, type InlineTable } from "@/vf"
import ChampionshipRegistrationChangeRequest from "./ChampionshipRegistrationChangeRequest.vue"

defineProps<{
    changeRequest: ChampionshipRegistrationTeamChangeRequest
    team: ChampionshipRegistrationTeam
    inlineTable: InlineTable
}>()

const trans = defineTranslations({
    change_request_title: {
        de: "Änderungsanfrage vom {date}",
        en: "Change Requests from {date}",
    },
    requested_at: {
        de: "Angefragt am {date}",
        en: "Requested on {date}",
    },
    cancelled_at: {
        de: "Abgebrochen am {date}",
        en: "Cancelled on {date}",
    },
    accepted_at: {
        de: "Angenommen am {date}",
        en: "Accepted on {date}",
    },
    accepted_automatically_at: {
        de: "Automatisch angenommen am {date}",
        en: "Accepted automatically on {date}",
    },
    declined_at: {
        de: "Abgelehnt am {date}",
        en: "Declined on {date}",
    },
})
</script>
<template>
    <div
        class="d-flex align-items-center py-3 border-bottom border-gray uploadable"
        :class="{ 'bg-primary text-white': inlineTable.rowIsOpen(changeRequest.id) }"
        @click="inlineTable.open({ changeRequest, team }, ChampionshipRegistrationChangeRequest, changeRequest.id!)"
    >
        <RotateChevron :open="inlineTable.rowIsOpen(changeRequest.id)" class="mx-3" />

        <div>
            <div>
                {{ trans("change_request_title", { date: $date(changeRequest.createdAt) }) }}
            </div>

            <div class="small" :class="inlineTable.rowIsOpen(changeRequest.id) ? 'text-white' : 'text-muted'">
                <template v-if="changeRequest.state === 'Requested'">
                    <i class="far fa-fw fa-clock"></i>
                    {{ trans("requested_at", { date: $datetime(changeRequest.createdAt!) }) }}
                </template>
                <template v-if="changeRequest.state === 'Cancelled'">
                    <i class="far fa-fw fa-times-circle text-danger"></i>
                    {{ trans("cancelled_at", { date: $datetime(changeRequest.processedAt!) }) }}
                </template>
                <template v-if="changeRequest.state === 'Approved'">
                    <i class="fa fa-fw fa-check-circle text-success"></i>
                    {{
                        trans(changeRequest.isAutoAccepted ? "accepted_automatically_at" : "accepted_at", {
                            date: $datetime(changeRequest.processedAt!),
                        })
                    }}
                </template>
                <template v-if="changeRequest.state === 'Declined'">
                    <i class="fa fa-fw fa-times-circle text-danger"></i>
                    {{ trans("declined_at", { date: $datetime(changeRequest.processedAt!) }) }}
                </template>
            </div>
        </div>
    </div>

    <VfComposeOpenRow :inline-table="inlineTable" :row-id="changeRequest.id!"></VfComposeOpenRow>
</template>
